 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/text/Title'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
 import TEXTFRONTMATTER001 from '@/components/text/Frontmatter001'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXTFOREWORD from '@/components/text/Foreword'
 import TEXTFRONTMATTER002 from '@/components/text/Frontmatter002'
 import TEXTINTRODUCTION from '@/components/text/Introduction'
 import TEXTFRONTMATTER003 from '@/components/text/Frontmatter003'
 import TEXTFRONTMATTER004 from '@/components/text/Frontmatter004'
 import TEXTCHAPTER001 from '@/components/text/Chapter001'
 import TEXTCHAPTER001SEC1 from '@/components/text/Chapter001sec1'
 import TEXTCHAPTER001SEC1A from '@/components/text/Chapter001sec1a'
 import TEXTCHAPTER001SEC12 from '@/components/text/Chapter001sec1-2'
 import TEXTCHAPTER001SEC2 from '@/components/text/Chapter001sec2'
 import TEXTCHAPTER001SEC24 from '@/components/text/Chapter001sec2-4'
 import TEXTCHAPTER001SEC24A from '@/components/text/Chapter001sec2-4a'
 import TEXTCHAPTER001SEC3 from '@/components/text/Chapter001sec3'
 import TEXTCHAPTER001SEC3A from '@/components/text/Chapter001sec3a'
 import TEXTCHAPTER001SEC36 from '@/components/text/Chapter001sec3-6'
 import TEXTCHAPTER001SEC36A from '@/components/text/Chapter001sec3-6a'
 import TEXTCHAPTER001SEC36B from '@/components/text/Chapter001sec3-6b'
 import TEXTCHAPTER001SEC4 from '@/components/text/Chapter001sec4'
 import TEXTCHAPTER001SEC4A from '@/components/text/Chapter001sec4a'
 import TEXTCHAPTER001SEC48 from '@/components/text/Chapter001sec4-8'
 import TEXTCHAPTER001SEC5 from '@/components/text/Chapter001sec5'
 import TEXTCHAPTER001SEC510 from '@/components/text/Chapter001sec5-10'
 import TEXTCHAPTER001SEC510A from '@/components/text/Chapter001sec5-10a'
 import TEXTCHAPTER002 from '@/components/text/Chapter002'
 import TEXTCHAPTER002SEC6 from '@/components/text/Chapter002sec6'
 import TEXTCHAPTER002SEC612 from '@/components/text/Chapter002sec6-12'
 import TEXTCHAPTER002SEC612A from '@/components/text/Chapter002sec6-12a'
 import TEXTCHAPTER002SEC7 from '@/components/text/Chapter002sec7'
 import TEXTCHAPTER002SEC714 from '@/components/text/Chapter002sec7-14'
 import TEXTCHAPTER002SEC714A from '@/components/text/Chapter002sec7-14a'
 import TEXTCHAPTER002SEC8 from '@/components/text/Chapter002sec8'
 import TEXTCHAPTER002SEC816 from '@/components/text/Chapter002sec8-16'
 import TEXTCHAPTER002SEC816A from '@/components/text/Chapter002sec8-16a'
 import TEXTCHAPTER002SEC9 from '@/components/text/Chapter002sec9'
 import TEXTCHAPTER002ASEC918 from '@/components/text/Chapter002asec9-18'
 import TEXTCHAPTER002ASEC918A from '@/components/text/Chapter002asec9-18a'
 import TEXTCHAPTER003 from '@/components/text/Chapter003'
 import TEXTCHAPTER003SEC10 from '@/components/text/Chapter003sec10'
 import TEXTCHAPTER003SEC1020 from '@/components/text/Chapter003sec10-20'
 import TEXTCHAPTER003SEC1020A from '@/components/text/Chapter003sec10-20a'
 import TEXTCHAPTER003SEC11 from '@/components/text/Chapter003sec11'
 import TEXTCHAPTER003SEC1122 from '@/components/text/Chapter003sec11-22'
 import TEXTCHAPTER003SEC1122A from '@/components/text/Chapter003sec11-22a'
 import TEXTCHAPTER003SEC1122B from '@/components/text/Chapter003sec11-22b'
 import TEXTCHAPTER003SEC12 from '@/components/text/Chapter003sec12'
 import TEXTCHAPTER003SEC12A from '@/components/text/Chapter003sec12a'
 import TEXTCHAPTER003SEC1224 from '@/components/text/Chapter003sec12-24'
 import TEXTCHAPTER003SEC13 from '@/components/text/Chapter003sec13'
 import TEXTCHAPTER003SEC1326 from '@/components/text/Chapter003sec13-26'
 import TEXTCHAPTER003SEC1326A from '@/components/text/Chapter003sec13-26a'
 import TEXTCHAPTER004 from '@/components/text/Chapter004'
 import TEXTCHAPTER004SEC14 from '@/components/text/Chapter004sec14'
 import TEXTCHAPTER004SEC14A from '@/components/text/Chapter004sec14a'
 import TEXTCHAPTER004SEC1428 from '@/components/text/Chapter004sec14-28'
 import TEXTCHAPTER004SEC15 from '@/components/text/Chapter004sec15'
 import TEXTCHAPTER004SEC1530 from '@/components/text/Chapter004sec15-30'
 import TEXTCHAPTER004SEC1530A from '@/components/text/Chapter004sec15-30a'
 import TEXTCHAPTER004SEC16 from '@/components/text/Chapter004sec16'
 import TEXTCHAPTER004SEC16A from '@/components/text/Chapter004sec16a'
 import TEXTCHAPTER004SEC1632 from '@/components/text/Chapter004sec16-32'
 import TEXTCHAPTER004SEC17 from '@/components/text/Chapter004sec17'
 import TEXTCHAPTER004SEC17A from '@/components/text/Chapter004sec17a'
 import TEXTCHAPTER004SEC1734 from '@/components/text/Chapter004sec17-34'
 import TEXTCHAPTER004SEC18 from '@/components/text/Chapter004sec18'
 import TEXTCHAPTER004SEC18A from '@/components/text/Chapter004sec18a'
 import TEXTCHAPTER004SEC1836 from '@/components/text/Chapter004sec18-36'
 import TEXTCHAPTER004SEC1836A from '@/components/text/Chapter004sec18-36a'
 import TEXTCHAPTER005 from '@/components/text/Chapter005'
 import TEXTCHAPTER005SEC19 from '@/components/text/Chapter005sec19'
 import TEXTCHAPTER005SEC1938 from '@/components/text/Chapter005sec19-38'
 import TEXTCHAPTER005SEC1938A from '@/components/text/Chapter005sec19-38a'
 import TEXTCHAPTER005SEC20 from '@/components/text/Chapter005sec20'
 import TEXTCHAPTER005SEC20A from '@/components/text/Chapter005sec20a'
 import TEXTCHAPTER005SEC2040 from '@/components/text/Chapter005sec20-40'
 import TEXTCHAPTER005SEC21 from '@/components/text/Chapter005sec21'
 import TEXTCHAPTER005SEC2142 from '@/components/text/Chapter005sec21-42'
 import TEXTCHAPTER005SEC2142A from '@/components/text/Chapter005sec21-42a'
 import TEXTCHAPTER006 from '@/components/text/Chapter006'
 import TEXTCHAPTER006SEC22 from '@/components/text/Chapter006sec22'
 import TEXTCHAPTER006SEC2244 from '@/components/text/Chapter006sec22-44'
 import TEXTCHAPTER006SEC2244A from '@/components/text/Chapter006sec22-44a'
 import TEXTCHAPTER006SEC23 from '@/components/text/Chapter006sec23'
 import TEXTCHAPTER006SEC2346 from '@/components/text/Chapter006sec23-46'
 import TEXTCHAPTER006SEC24 from '@/components/text/Chapter006sec24'
 import TEXTCHAPTER006SEC2448 from '@/components/text/Chapter006sec24-48'
 import TEXTCHAPTER006SEC2346A from '@/components/text/Chapter006sec23-46a'
 import TEXTCHAPTER006SEC25 from '@/components/text/Chapter006sec25'
 import TEXTCHAPTER006SEC2550 from '@/components/text/Chapter006sec25-50'
 import TEXTCHAPTER006SEC2550A from '@/components/text/Chapter006sec25-50a'
 import TEXTCHAPTER007 from '@/components/text/Chapter007'
 import TEXTCHAPTER006SEC26 from '@/components/text/Chapter006sec26'
 import TEXTCHAPTER006SEC26A from '@/components/text/Chapter006sec26a'
 import TEXTCHAPTER006SEC2652 from '@/components/text/Chapter006sec26-52'
 import TEXTCHAPTER006SEC27 from '@/components/text/Chapter006sec27'
 import TEXTCHAPTER006SEC27A from '@/components/text/Chapter006sec27a'
 import TEXTCHAPTER006SEC2754 from '@/components/text/Chapter006sec27-54'
 import TEXTCHAPTER006SEC28 from '@/components/text/Chapter006sec28'
 import TEXTCHAPTER006SEC28A from '@/components/text/Chapter006sec28a'
 import TEXTCHAPTER006SEC2856 from '@/components/text/Chapter006sec28-56'
 import TEXTCHAPTER006SEC29 from '@/components/text/Chapter006sec29'
 import TEXTCHAPTER006SEC2958 from '@/components/text/Chapter006sec29-58'
 import TEXTCHAPTER006SEC2958A from '@/components/text/Chapter006sec29-58a'
 import TEXTCHAPTER006SEC30 from '@/components/text/Chapter006sec30'
 import TEXTCHAPTER006SEC3060 from '@/components/text/Chapter006sec30-60'
 import TEXTCHAPTER006SEC3060A from '@/components/text/Chapter006sec30-60a'
 import LOVE_2 from '@/components/love_2'
 import TEXTACKNOWLEDGMENTS from '@/components/text/Acknowledgments'
 import TEXTINDEX from '@/components/text/Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/Foreword",
 			"name" : "text/Foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/text/Frontmatter002",
 			"name" : "text/Frontmatter002",
 			"component" : TEXTFRONTMATTER002
 		},
 		{
 			"path" : "/text/Introduction",
 			"name" : "text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/text/Frontmatter003",
 			"name" : "text/Frontmatter003",
 			"component" : TEXTFRONTMATTER003
 		},
 		{
 			"path" : "/text/Frontmatter004",
 			"name" : "text/Frontmatter004",
 			"component" : TEXTFRONTMATTER004
 		},
 		{
 			"path" : "/text/Chapter001",
 			"name" : "text/Chapter001",
 			"component" : TEXTCHAPTER001
 		},
 		{
 			"path" : "/text/Chapter001sec1",
 			"name" : "text/Chapter001sec1",
 			"component" : TEXTCHAPTER001SEC1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js